export const APIARY_EVENT_LIST_VIEW = "/apiary-events"
export const NEW_APIARY_EVENT_VIEW = APIARY_EVENT_LIST_VIEW + "/new"
export const APIARY_EVENT_VIEW = `${APIARY_EVENT_LIST_VIEW}/:apiaryEventId`
